import moment from "moment";
import "./SubHeader.css";

function SubHeader({ data }) {
  return (
    <div className="hero-container">
      <div className="container ">
        <div className="row py-4">
          <div className="col-md-12 herosection">
            <div className="d-flex flex-column flex-md-row">
              <div className="d-flex">
                <img
                  src="https://assets.fyers.in/verified-pnl/images/green-tick.svg"
                  alt="Green Tick Symbol"
                  width={24}
                />
                <h5 className="mb-0 pl-3">Verified P&L by FYERS</h5>
              </div>
              {data && data.shared_date ? (
                <p className="pl-5 mb-0 pt-1">
                  Generated on{" "}
                  <span className="black500">
                    {moment
                      .unix(data.shared_date)
                      .format("DD MMM YYYY hh:mm a")}
                  </span>
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubHeader;
